import { render, staticRenderFns } from "./PurchaseAttention.vue?vue&type=template&id=49178a70&scoped=true"
import script from "./PurchaseAttention.vue?vue&type=script&lang=js"
export * from "./PurchaseAttention.vue?vue&type=script&lang=js"
import style0 from "./PurchaseAttention.vue?vue&type=style&index=0&id=49178a70&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49178a70",
  null
  
)

export default component.exports